/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CountryData } from './CountryData';
import {
    CountryDataFromJSON,
    CountryDataFromJSONTyped,
    CountryDataToJSON,
    CountryDataToJSONTyped,
} from './CountryData';

/**
 * 
 * @export
 * @interface DailyCountryData
 */
export interface DailyCountryData {
    /**
     * 
     * @type {Array<CountryData>}
     * @memberof DailyCountryData
     */
    topCountries?: Array<CountryData>;
}

/**
 * Check if a given object implements the DailyCountryData interface.
 */
export function instanceOfDailyCountryData(value: object): value is DailyCountryData {
    return true;
}

export function DailyCountryDataFromJSON(json: any): DailyCountryData {
    return DailyCountryDataFromJSONTyped(json, false);
}

export function DailyCountryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyCountryData {
    if (json == null) {
        return json;
    }
    return {
        
        'topCountries': json['topCountries'] == null ? undefined : ((json['topCountries'] as Array<any>).map(CountryDataFromJSON)),
    };
}

export function DailyCountryDataToJSON(json: any): DailyCountryData {
    return DailyCountryDataToJSONTyped(json, false);
}

export function DailyCountryDataToJSONTyped(value?: DailyCountryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'topCountries': value['topCountries'] == null ? undefined : ((value['topCountries'] as Array<any>).map(CountryDataToJSON)),
    };
}

